// Helper to generate consistent storage keys for user preferences
// Format: user-pref-{name}-{userId}
export function useStorageKey(name: string): string {
  const user = useSupabaseUser()
  const userId = user.value?.sub ?? '0'
  return `user-pref-${name}-${userId}`
}

